import { retrieversAdapter } from './reducer'

export const { selectAll: selectAllRetrievers } = retrieversAdapter.getSelectors(
  state => state.retrievers
)

export const { selectAll: selectAllRetrieversTimeZones } = retrieversAdapter.getSelectors(
  state => state.retrievers.timezones
)
